import { render, staticRenderFns } from "./VideoComponentNoodplan.vue?vue&type=template&id=ceeffa84&scoped=true"
import script from "./VideoComponentNoodplan.vue?vue&type=script&lang=js"
export * from "./VideoComponentNoodplan.vue?vue&type=script&lang=js"
import style0 from "./VideoComponentNoodplan.vue?vue&type=style&index=0&id=ceeffa84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceeffa84",
  null
  
)

export default component.exports